import { reduxForm } from 'redux-form';
import Component from './ChangeUserPasswordForm';
import { validate, initialValues } from './schema';

const Form = reduxForm({
  form: 'changeUserPasswordForm',
  initialValues,
  validate,
})(Component);

export default Form;
